import { useMutation } from '@tanstack/react-query';
import { accountSummaryV2CacheKey, profileDetailsCacheKey } from 'syf-api';
import queryClient from '../../const/query-client';
import ENDPOINTS from '../../const/endpoints';
import { fetchConfig } from '../../helpers';
import { accountCreditLimitChangeCacheKey } from './account-credit-limit-change-key';
function useAccountCreditLimitChange({ config, keyProps, mutationOptions = {} }) {
    const fetchWrapper = fetchConfig(config);
    const { accountId, requestedLimit, income, promoStrategyCode, merchantNumber } = keyProps;
    return useMutation({
        mutationKey: accountCreditLimitChangeCacheKey(keyProps),
        mutationFn: () => {
            return fetchWrapper(ENDPOINTS.creditLimitChange, {
                method: 'PUT',
                body: JSON.stringify({
                    'cipher.accountId': accountId,
                    accountIdType: 'guid',
                    requestedLimit,
                    income,
                    promoStrategyCode,
                    merchantNumber
                })
            });
        },
        onSuccess: () => {
            const accountIdType = keyProps?.accountIdType;
            // Invalidating account summary
            queryClient.invalidateQueries(accountSummaryV2CacheKey({
                accountId,
                accountIdType
            }));
            // Invalidating Profile
            queryClient.invalidateQueries(profileDetailsCacheKey({
                accountId,
                accountIdType
            }));
        },
        ...mutationOptions
    });
}
export default useAccountCreditLimitChange;
